import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    marginTop: 10,
    width: '90%',
    borderWidth: 1,
    borderColor: '#dbdbdb',
    borderRadius: 8
  },
  hotelDataAndReserveData: {
    width: '100%',
    flexDirection: 'row'
  },
  header: {
    alignItems: 'center'
  },
  QRCodePart: {
    width: '25%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  reserveData: {
    width: '75%'
  },
  priceAndName: {
    width: '100%'
  },
  hotelDetail: {
    width: '100%'
  }
})
export default styles
